module.exports = __webpack_public_path__ + "img/banner_R1.e06dc000.png";